const witNotify = function ({
  time = 3000,
  message = '',
  type = 'error',
  top = 0
}) {
  uni.$emit('notify', { message, type, duration: time })
}

export default witNotify
